// A single presence session ID per tab/page load, shared by the presence
// connection (avatar identity) and every API save request (echo filtering).
// Kept in memory only: saves and presence in this tab always use the same
// value, which is all the same-session filtering needs. A reload gets a new
// ID, which simply makes the tab a fresh presence session.
function generateSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

export const PRESENCE_SESSION_ID = generateSessionId()
export const PRESENCE_SESSION_HEADER = 'X-Presence-Session-Id'
